import { jsx as _jsx } from "react/jsx-runtime";
import { RliSdk } from '@rocketlane/rli-internal-sdk';
import { useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import { ExpenseEventsMap } from 'events/expenses';
import { ProjectEventsMap } from 'events/projects';
import { ResourceRequestEventsMap } from 'events/resource-request';
import { TaskEventsMap } from 'events/tasks';
import { LDS_URL } from 'marketplace/api/lds-http-client';
import { useGetMarketplaceAuthToken } from 'marketplace/hooks/use-marketplace-hooks';
import { useWidgetCommunicationHandler } from 'marketplace/hooks/use-widget-communication-handler';
import { floatUidString } from 'utils/uid';
export const IframeWrapper = styled.div`
  display: none;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;
export const AddLdsScripts = ()=>{
    const { registerCallbacks, invokeServerMethodLocal, show } = useWidgetCommunicationHandler(-1, {
        isCustomerPortal: false,
        isLds: true
    });
    const iframeRef = useRef(null);
    const iframeId = useMemo(()=>floatUidString(), []);
    const { data: marketplaceAuthToken } = useGetMarketplaceAuthToken();
    useEffect(()=>{
        if (iframeRef.current === null && (marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token)) {
            RliSdk === null || RliSdk === void 0 ? void 0 : RliSdk.registerWidget({
                appId: 1,
                apiKey: marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token,
                baseUrl: LDS_URL,
                id: 'lds-client-events',
                src: `${LDS_URL}/client-events`,
                widgetIdentifier: 'lds-client-events',
                events: {
                    ...TaskEventsMap,
                    ...ProjectEventsMap,
                    ...ExpenseEventsMap,
                    ...ResourceRequestEventsMap
                },
                data: {
                    GET_USER_DATA: 'user',
                    // GET_USER_PROJECTS: 'user_projects',
                    GET_USER_ACCOUNT: 'account'
                },
                parent: document.getElementById('lds-client-events')
            }).then((widget)=>{
                iframeRef.current = widget;
                registerCallbacks(widget);
            });
        }
        return ()=>{
            if (iframeRef.current) {
                var _iframeRef_current, _RliSdk_deRegisterWidget;
                RliSdk === null || RliSdk === void 0 ? void 0 : (_RliSdk_deRegisterWidget = RliSdk.deRegisterWidget) === null || _RliSdk_deRegisterWidget === void 0 ? void 0 : _RliSdk_deRegisterWidget.call(RliSdk, (_iframeRef_current = iframeRef.current) === null || _iframeRef_current === void 0 ? void 0 : _iframeRef_current.id);
                iframeRef.current = null;
            }
        };
    }, [
        iframeId,
        invokeServerMethodLocal,
        registerCallbacks,
        show,
        marketplaceAuthToken === null || marketplaceAuthToken === void 0 ? void 0 : marketplaceAuthToken.token
    ]);
    return /*#__PURE__*/ _jsx(IframeWrapper, {
        id: "lds-client-events"
    });
};
